import api from './api'

export const operatorService = {
  // Get all operators with filters
  getAll: async (params = {}) => {
    const response = await api.get('/operators', { params })
    return response.data
  },

  // Get operator by ID
  getById: async (id) => {
    const response = await api.get(`/operators/${id}`)
    return response.data
  },

  // Create operator
  create: async (data) => {
    const response = await api.post('/operators', data)
    return response.data
  },

  // Update operator
  update: async (id, data) => {
    const response = await api.put(`/operators/${id}`, data)
    return response.data
  },

  // Delete operator
  delete: async (id) => {
    const response = await api.delete(`/operators/${id}`)
    return response.data
  }
}

export default operatorService
